const state = {
    nuevaVenta:{
        tipo: {},
        tipoPago:[],
        cliente: {},
        productos: []
    },
    ingresos: [],
    nota_credito: [],
    boletas: [],
    facturas:[],
    usuarios:[],
    encargos: [],
    saldosFavor: [],
    marcas:[],
    marcaProducto:[],
    productoMiranda: [],
    modelos:[],
    categorias:[],
    clasificacion:[],
    familias:[],
    vehiculos:[],
    proveedores:[],
    transportes:[],
    productos:[],
    cliente: [],
    sucursales: [],
    productoVenta: [],
    producto:'',
    ordenCompra:[],
    pre_ingresos:[],
    voucher:[],
    proveedor:'',
    status:'',
    transporte:'',
    token: localStorage.getItem('token') || '',
    user:'',
    isLoggedIn: !!localStorage.getItem('token'),
    sidebar: {
        opened: false,
        withoutAnimation: false,
    },
    config: {
        googleMaps: {
            apiKey: 'AIzaSyBNAqPrTQoz9P4NBlDDyfxrnKiafkaL8iQ',
        },
        windowMatchSizeLg: '(min-width: 992px)',
        palette: {
            primary: '#4ae387',
            danger: '#e34a4a',
            info: '#4ab2e3',
            success: '#db76df',
            warning: '#f7cc36',
            white: '#fff',
            black: '#000',
            fontColor: '#34495e',
            transparent: 'transparent',
            lighterGray: '#ddd',
        },
    },
    isLoading: true,
}
export {state}
